module.exports = __webpack_public_path__ + "img/stott-pilates.8b945f58.jpg";